import React from "react";

const MyModal = ({
		active,
	  header,
		children,
	  onClose = ()=>{}
	}) => {
	return (
		<div className={`my-modal ${active ? 'active' : ''}`}>
			<div onClick={onClose} className='close-area'/>
			<div className="modal-content">
				<div className="modal-header">
					<span onClick={onClose} className="close">&times;</span>
					<h2>{header}</h2>
				</div>
				<div className="modal-body">
					{children}
				</div>
			</div>

		</div>
	)
}

export default React.memo(MyModal);